//#region Interfaces
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'inversify';
//#endregion
//#region Service implemented classes
// - Firebase services
import { AuthorizeService, CircleService, CommentService, CommonService, ImageGalleryService, NotificationService, PostService, UserService, VoteService, StorageService } from 'data/firestoreClient/services';
//#endregion
var ServiceProvide = /** @class */ (function () {
    function ServiceProvide() {
        /**
         * Create instant for Authorize Service
         *
         * @memberof ServiceProvide
         */
        this.createAuthorizeService = function () {
            return new AuthorizeService();
        };
        /**
         * Create instant for Circle Service
         *
         * @memberof ServiceProvide
         */
        this.createCircleService = function () {
            return new CircleService();
        };
        /**
         * Create instant for Comment Service
         *
         * @memberof ServiceProvide
         */
        this.createCommentService = function () {
            return new CommentService();
        };
        /**
         * Create instant for Common Service
         *
         * @memberof ServiceProvide
         */
        this.createCommonService = function () {
            return new CommonService();
        };
        /**
         * Create instant for ImageGallery Service
         *
         * @memberof ServiceProvide
         */
        this.createImageGalleryService = function () {
            return new ImageGalleryService();
        };
        /**
         * Create instant for Notification Service
         *
         * @memberof ServiceProvide
         */
        this.createNotificationService = function () {
            return new NotificationService();
        };
        /**
         * Create instant for Post Service
         *
         * @memberof ServiceProvide
         */
        this.createPostService = function () {
            return new PostService();
        };
        /**
         * Create instant for User Service
         *
         * @memberof ServiceProvide
         */
        this.createUserService = function () {
            return new UserService();
        };
        /**
         * Create instant for Vote Service
         *
         * @memberof ServiceProvide
         */
        this.createVoteService = function () {
            return new VoteService();
        };
        /**
         * Create instant for Vote Service
         *
         * @memberof ServiceProvide
         */
        this.createStorageService = function () {
            return new StorageService();
        };
    }
    ServiceProvide = __decorate([
        injectable()
    ], ServiceProvide);
    return ServiceProvide;
}());
export { ServiceProvide };



//////////////////
// WEBPACK FOOTER
// ./src/core/factories/serviceProvide.ts
// module id = 648
// module chunks = 50